// DS: C92
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationCoreBadgeList from '../coreBadge/CoreBadgeList/presets/DeviationCoreBadgeList';
import FaveStat from './FaveStat';
import CommentStat from './CommentStat';
import ViewStat from './ViewStat';
import SubscriberStat from './SubscriberStat';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Stat from './Stat';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { DeviationTypes } from '../types/deviation';
import { getDeviationType } from '../DeviationViews/_helpers';
import StampIcon from '../Das/StampIcon';
import { actions as modalActions } from '../Modals';
import { getCurrentUser, getCurrentUserHasCore, } from '../publicSession/selectors';
import DAProtectIconWithTooltip from '../DAProtectIconWithTooltip';
import s from './Stats.scss';
var Stats = function (_a) {
    var _b, _c, _d;
    var deviation = _a.deviation, showOnlyNumbers = _a.onlyNumbers, _e = _a.withFavouriteControl, withFavouriteControl = _e === void 0 ? true : _e, _f = _a.withCommentControl, withCommentControl = _f === void 0 ? true : _f, _g = _a.withViewCount, withViewCount = _g === void 0 ? true : _g, _h = _a.withDas, withDas = _h === void 0 ? true : _h, _j = _a.withSubscriberCount, withSubscriberCount = _j === void 0 ? false : _j, _k = _a.withBadges, withBadges = _k === void 0 ? true : _k, className = _a.className, statClassName = _a.statClassName, badgelistClassName = _a.badgelistClassName, onCommentClick = _a.onCommentClick;
    var isMobile = useContext(MobileContext);
    var hasDas = useFlag('digital_assets');
    var deviationType = getDeviationType(deviation);
    var onlyNumbers = !!(showOnlyNumbers || isMobile);
    var dispatch = useDispatch();
    var _l = useSelector(function (state) { return ({
        currentUser: getCurrentUser(state),
        hasCore: getCurrentUserHasCore(state),
    }); }), currentUser = _l.currentUser, hasCore = _l.hasCore;
    var isCurrentUserDeviationOwner = !!currentUser && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) === ((_b = deviation.author) === null || _b === void 0 ? void 0 : _b.userId);
    var daProtectLevel = deviation.extended && deviation.extended.isDaProtected
        ? hasCore
            ? 'active'
            : 'temporary'
        : 'inactive';
    return (React.createElement(Flex, { className: className, justifyContent: "space-between" },
        React.createElement(Flex, { alignItems: "center" },
            withFavouriteControl && (React.createElement(FaveStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers })),
            withCommentControl && (React.createElement(CommentStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers, withUserList: !isMobile, onClick: onCommentClick })),
            withViewCount && (React.createElement(ViewStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers })),
            withSubscriberCount && (React.createElement(SubscriberStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers })),
            hasDas && withDas && ((_c = deviation.digitalAsset) === null || _c === void 0 ? void 0 : _c.hasEditions) && (React.createElement(Stat, { deviation: deviation, icon: StampIcon, statNameLocaleKey: "deviation.stats.editions", statCount: (_d = deviation.digitalAsset) === null || _d === void 0 ? void 0 : _d.numEditions, onlyNumbers: onlyNumbers, biData: BiData({
                    evid: 2,
                    click_info: 'edition',
                    sectionname: BiContextProvidedValue,
                    widgetname: BiContextProvidedValue,
                    typeid: BiContextProvidedValue,
                    itemid: BiContextProvidedValue,
                }), onClick: function () {
                    dispatch(modalActions.pushDasModal('manage', deviation));
                } })),
            deviationType === DeviationTypes.IMAGE &&
                isCurrentUserDeviationOwner && (React.createElement(DAProtectIconWithTooltip, { withLabel: true, variant: daProtectLevel, className: s['da-protect'] }))),
        withBadges && (React.createElement(DeviationCoreBadgeList, { deviation: deviation, className: classnames(badgelistClassName, s['badges']) }))));
};
export default Stats;
//# sourceMappingURL=Stats.js.map